(function ($) {
  $(window).on('load', function() {
    if (! $('.rellax').length) {
      return;
    }
    var rellax = new Rellax('.rellax', {
      center: true,
      breakpoints: {
        mobile: {
          disable: true,
        },
      },
    });

    rellax.refresh();
  });

  var wpContactForm = $('.wpcf7-form');
  if (wpContactForm && wpContactForm.length) {
    var wpcf7Elm = document.querySelector( '.wpcf7' );
 
    wpcf7Elm.addEventListener( 'wpcf7invalid', function( event ) {
      $('.wpcf7-form').find('.wpcf7-submit').attr('disabled', false);
    }, false );
    wpcf7Elm.addEventListener( 'wpcf7mailfailed', function( event ) {
      $('.wpcf7-form').find('.wpcf7-submit').attr('disabled', false);
    }, false );
    wpcf7Elm.addEventListener( 'wpcf7submit', function( event ) {
      $('.wpcf7-form').find('.wpcf7-submit').attr('disabled', false);
    }, false );
    
    $('.wpcf7-form').on('submit', function() {
      let wpSubmit = $(this);
      wpSubmit.find('.wpcf7-submit').attr('disabled', true);
    });
  }
})(jQuery);

let havingSingle = document.querySelector('body.single-post');
if (havingSingle) {
  const embedPattern = /\[embed\](https?:\/\/youtu\.be\/([a-zA-Z0-9_-]+))\[\/embed\]/g;
  const body = document.body;
  body.innerHTML = body.innerHTML.replace(embedPattern, (match, url, videoId) => {
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube.com/embed/${videoId}`;
      iframe.width = '560';
      iframe.height = '281';
      iframe.allowFullscreen = true;

      const paragraph = document.createElement('p');
      paragraph.appendChild(iframe);

      return paragraph.outerHTML;
  });
}

let wpcf7Form = document.querySelector('.wpcf7-form');
if (wpcf7Form) {
  document.addEventListener('wpcf7mailsent', function(event) {
    var inputWrappers = document.querySelectorAll(".input-wrapper");
    inputWrappers.forEach(function(element) {
        element.style.display = "none";
    });

    var formAttrWrappers = document.querySelectorAll(".forms-attr");
    formAttrWrappers.forEach(function(element) {
        element.style.display = "none";
    });

    let submitBtn = document.querySelector('.wpcf7-submit.wpcf7-form-control');
    if (submitBtn) {
      submitBtn.style.display = "none";
    }

    let bodyWrapper = document.querySelector('.body-wrapper');
    if (bodyWrapper) {
      bodyWrapper.style.display = "none";
    }

    let formWithCol = document.querySelectorAll('.form-with-col');
    formWithCol.forEach(function(element) {
      element.style.display = "none";
    });

    let responseOut = document.querySelector('.wpcf7 form.resetting .wpcf7-response-output');
    if (responseOut) {
      responseOut.style.display = "block";
    }

    if (event.target.wpcf7.id == 803) {
      let contactRespose = document.querySelector('.wpcf7-response-overwrite');
      contactRespose.style.display = 'block';

      let cadWrapper = document.querySelector('.form-wrapper.cad-form');
      if (cadWrapper) {
        $("html,body").animate(
          {
            scrollTop: $(".form-wrapper.cad-form").offset().top - 128,
          },
          "slow"
        );
      }
    }

    if (event.target.wpcf7.id == 782) {
      location.href = '/letstalk/thank-you-for-reaching-out/';
      return false;
    }
    
  }, false);
}
